import React, { useEffect, useState } from "react";
import CreateSession from "./CreateSession";
import Complete from "./Complete";
import { Link, Route, useNavigate, useParams } from "react-router-dom";
import { Routes } from "../../constants";
import { injectModels } from "../../redux/injectModels";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"; // icons form react-icons
import { IconContext } from "react-icons";
import UpdateSession from "./UpdateSession";
import ViewSession from "./ViewSession";

const Session = (props) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [editModelOpen,   setEditModelOpen] = useState(false);
  const [viewModelOpen,   setViewModelOpen] = useState(false);
  const [id, setId] = useState();
  
  const role = localStorage.getItem("userRole");

  const rowsPerPage = 8;
  const offset = currentPage * rowsPerPage;
  let paginatedData = [];
  try {
    if (Array.isArray(filteredData)) {
      paginatedData = filteredData.slice(offset, offset + rowsPerPage);
    } else {
      throw new Error("filteredData is not an array");
    }
  } catch (exception) {
    paginatedData = [];
    console.log(exception);
  }

  useEffect(() => {
    getSession();
    // const handleBackButton = (e) => {
      // if (window.location.pathname === `/session`) {
        // console.log('Browser back button clicked on session page', e);
  //  
      // }
    // };
    // return () => {
      // window.removeEventListener('popstate',handleBackButton);
    // };

  }, [props.admin.loadingSession,props.admin.loadingUpadteSession]);



  const getSession = async () => {
    props.application.setLoading(true);
    try {
      const res = await props.admin.getAllActiveSession();
      if (res) {
        setFilteredData(res && res.session);

        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };
  const handleDeleteSession = async (id) => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#009462",
      cancelButtonColor: "#314a5f",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          props.application.setLoading(true);
          const res = await props.admin.deleteSession(id);
          if (res.success === true) {
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            getSession();
            props.application.setLoading(false);
          } else {
            props.application.setLoading(false);
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        } catch (error) {
          console.log(error);
          props.application.setLoading(false);
          toast.dismiss();
          toast.success("Something went wrong!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    });
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);

    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }

    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (selected === pageCount - 1 || pageCount === 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          pageClassName={"page-item"}
          pageCount={pageCount}
          pageRangeDisplayed={0}
          marginPagesDisplayed={2}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          containerClassName="pagination"
          activeClassName="active"
          breakLabel="..."
          previousLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillLeftCircle />
            </IconContext.Provider>
          }
          nextLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillRightCircle />
            </IconContext.Provider>
          }
          renderOnZeroPageCount={null}
          disableInitialCallback={true}
        />
      );
    }
    return null;
  };

  const handleLunchSession = async (id ,userId) => {
    props.application.setLoading(true);
    try {
      const currentTime = Math.floor(Date.now() / 1000);
      const data = {
        launch_time: currentTime,
      };
      const res = await props.admin.lunchSession(id, data);
      if (res) {
        toast.dismiss();
        toast.success(res.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate(`/lunch-session/live-session/${id}`, {state:{userId}});
        props.application.setLoading(false);
      } else {
        toast.dismiss();
        toast.error(res.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        getSession();
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleUpadteSessionModelOpen = (id)=>{
    setEditModelOpen(true);
    setId(id)
  }
  const handleUpadteSessionModelClose = ()=>{
    setEditModelOpen(false);
  }
  const handleViewSessionModelOpen = (id)=>{
    setViewModelOpen(true);
    setId(id)
  }
  const handleViewSessionModelClose = ()=>{
    setViewModelOpen(false);
  }
  return (
    <main id="main" className="main">
      <div className="pagetitle mb-3">
        <h1>Session Management</h1>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={Routes.DASHBOARD}>Home</Link>
            </li>
            <li className="breadcrumb-item active">Session Management</li>
          </ol>
        </nav>
      </div>
      <section className="section dashboard">
        <div className="row">
          <div className="col-12">
            <div className="card recent-sales overflow-auto">
              <div className="card-body p-3">
                <div className="data-se">
                  <div className="d-flex justify-content-between">
                    <ul
                      className="nav nav-pills mb-3"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link btn btn-outline-secondary active"
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                        >
                          Active
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link btn btn-outline-secondary"
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          Completed
                        </button>
                      </li>
                    </ul>
                    <div>
                      <a
                        href="#"
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#largeModal"
                      >
                        Create Session
                      </a>
                    </div>
                  </div>
                  <div className="tab-content pt-2" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {role === "admin" && <th>User name</th>}
                            <th>Title</th>
                            <th>Job profile</th>
                            <th>Company</th>
                            <th>Interviewer(client)</th>
                            <th>Interviewee(user)</th>
                            <th>topic</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedData && paginatedData.length > 0 ? (
                            paginatedData.map((item) => (
                              <tr key={item.id}>
                                {role === "admin" && <td>{item.username}</td>}
                                <td>{item.title}</td>
                                <td>{item.job_profile}</td>
                                <td>{item.company_name}</td>
                                <td>{item.client}</td>
                                <td>{item.user}</td>
                                <td>{item.topic}</td>
                                <td>
                                  <button
                                    className="btn btn-dark btn-sm m-0"
                                    onClick={() => handleLunchSession(item.id,item.user_id)}
                                  >
                                    <i className="bi bi-rocket-takeoff"></i>{" "}
                                    Launch
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-danger btn-sm m-0"
                                    onClick={() => handleDeleteSession(item.id)}
                                  >
                                    <i className="bi bi-trash-fill"></i>
                                  </button>
                                  &nbsp;
                                  <button
                                    // to={`/session/viewsession/${item.id}`}
                                    className="btn btn-success btn-sm m-0"
                                    onClick={()=>handleViewSessionModelOpen(item.id)}
                                  >
                                    <i className="bi bi-eye-fill"></i>
                                  </button>
                                  &nbsp;
                                  <button
                                    // to={`/session/editsession/${item.id}`}
                                    className="btn btn-primary btn-sm m-0"
                                    title="Update Session"
                                    onClick={()=> handleUpadteSessionModelOpen(item.id)}
                                  >
                                    <i className="bi bi-pencil-fill"></i>
                                  </button>
                                  &nbsp;
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10 mt-2" className="text-center">No results found!</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="table-footer">
                        <strong>Total Count: {filteredData.length}</strong>
                        {renderPagination()}
                      </div>
                    </div>
                    <Complete />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CreateSession />
     {editModelOpen && <UpdateSession id= {id} isOpen={editModelOpen} closeModal={handleUpadteSessionModelClose} props={props} /> } 
     {viewModelOpen && <ViewSession id= {id} isOpen={viewModelOpen} closeModal={handleViewSessionModelClose} props={props} /> } 
    
    </main>
  );
};
export default injectModels(["admin", "application"])(Session);
